const html = document.querySelector('html');

const normalFont = document.querySelector('.wcag__fonts-normal');
const largerFont = document.querySelector('.wcag__fonts-larger');
const largestFont = document.querySelector('.wcag__fonts-largest');

function setFontSize(pct) {
  html.style.fontSize = pct;
  if (normalFont)
    normalFont.setAttribute('aria-pressed', pct === '' ? 'true' : 'false');
  if (largerFont)
    largerFont.setAttribute('aria-pressed', pct === '66.5%' ? 'true' : 'false');
  if (largestFont)
    largestFont.setAttribute('aria-pressed', pct === '70%' ? 'true' : 'false');
}

if (normalFont) {
  normalFont.addEventListener('click', () => setFontSize(''));
}
if (largerFont) {
  largerFont.addEventListener('click', () => setFontSize('66.5%'));
}
if (largestFont) {
  largestFont.addEventListener('click', () => setFontSize('70%'));
}

const normalContrast = document.querySelector('.wcag__contrast-normal');
const highContrast = document.querySelector('.wcag__contrast-high');

function setContrast(high) {
  if (high) {
    document.body.classList.add('high-contrast');
  } else {
    document.body.classList.remove('high-contrast');
  }
  if (normalContrast)
    normalContrast.setAttribute('aria-pressed', high ? 'false' : 'true');
  if (highContrast)
    highContrast.setAttribute('aria-pressed', high ? 'true' : 'false');
}

if (normalContrast) {
  normalContrast.addEventListener('click', () => setContrast(false));
}
if (highContrast) {
  highContrast.addEventListener('click', () => setContrast(true));
}
